import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check } from 'lucide-react';
export function WhatYouGet() {
  const items = ['Guía de Sueño Express para Bebés (PDF paso a paso)', 'Lista de verificación para patrones nocturnos', 'Hoja de trabajo para evaluar métodos anteriores', 'Detalle completo del Método de Micro-pausas (3 fases)', 'Tablas de ajuste por edad (0-3, 4-7, 8-12 meses)', 'Mini-guía de audio con afirmaciones para la madre', 'Plantilla imprimible de registro de sueño'];
  return <section className="py-20" data-id="element-318">
      <div className="max-w-4xl mx-auto px-6" data-id="element-319">
        <FadeIn data-id="element-320">
          <div className="text-center mb-16" data-id="element-321">
            <h2 className="text-3xl md:text-4xl font-bold text-brown-dark mb-4" data-id="element-322">
              Todo lo que recibes hoy
            </h2>
            <p className="text-lg text-brown/80 font-serif" data-id="element-323">
              Todo lo que necesitas para recuperar tus noches, paso a paso.
            </p>
          </div>
        </FadeIn>

        <div className="bg-white rounded-3xl shadow-soft p-8 md:p-12 border border-cream-dark" data-id="element-324">
          <ul className="grid md:grid-cols-2 gap-x-8 gap-y-6" data-id="element-325">
            {items.map((item, index) => <FadeIn key={index} delay={index * 0.05} direction="up" data-id="element-326">
                <li className="flex items-start gap-4" data-id="element-327">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-accent/20 flex items-center justify-center mt-1" data-id="element-328">
                    <Check className="w-4 h-4 text-brown" data-id="element-329" />
                  </div>
                  <span className={item.includes('Bonus:') ? 'text-brown-dark font-bold' : 'text-brown-dark/80'} data-id="element-330">
                    {item}
                  </span>
                </li>
              </FadeIn>)}
          </ul>
        </div>
      </div>
    </section>;
}